import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "/aky", label: "Aky" },
  { to: "/lead-ai", label: "Lead.ai" },
  { to: "/research", label: "Research" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy", label: "Privacy" },
];

export const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="container-syni">
      <div className="footer-row">
        <div className="footer-brand">
          <Link to="/" className="footer-wordmark" data-testid="footer-wordmark">
            Syni.ai
          </Link>
          <span className="mono-label" data-testid="footer-place">Nairobi</span>
        </div>
        <nav className="footer-links" aria-label="Footer">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="footer-link" data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="footer-legal" data-testid="footer-legal">
        <span>© 2026 Syni.ai</span>
      </div>
    </div>
  </footer>
);

export default Footer;
